import {EChannel} from './notification.model';

export enum ERecipientType {
    FREELANCER = 'FREELANCER',
    CLIENT = 'CLIENT',
    ADMIN = 'ADMIN',
}

export enum EEventType {
    APPLICANT_REGISTERED = 'APPLICANT_REGISTERED',
    APPLICATION_ACCEPTED = 'APPLICATION_ACCEPTED',
    APPLICATION_REJECTED = 'APPLICATION_REJECTED',
    APPLICATION_SUBMITTED = 'APPLICATION_SUBMITTED',
    APPLICATION_DROPPED = 'APPLICATION_DROPPED',
    CLIENT_REGISTERED = 'CLIENT_REGISTERED',
    CLIENT_TOOL_PROPOSED = 'CLIENT_TOOL_PROPOSED',
    CLIENT_TOOL_PROPOSAL_REJECTED = 'CLIENT_TOOL_PROPOSAL_REJECTED',
    CLIENT_TOOL_PROPOSAL_ACCEPTED = 'CLIENT_TOOL_PROPOSAL_ACCEPTED',
    FREELANCER_TOOL_PROPOSED = 'FREELANCER_TOOL_PROPOSED',
    FREELANCER_TOOL_PROPOSAL_REJECTED = 'FREELANCER_TOOL_PROPOSAL_REJECTED',
    FREELANCER_TOOL_PROPOSAL_ACCEPTED = 'FREELANCER_TOOL_PROPOSAL_ACCEPTED',
    FREELANCER_BRAND_PROPOSED = 'FREELANCER_BRAND_PROPOSED',
    FREELANCER_BRAND_PROPOSAL_REJECTED = 'FREELANCER_BRAND_PROPOSAL_REJECTED',
    FREELANCER_BRAND_PROPOSAL_ACCEPTED = 'FREELANCER_BRAND_PROPOSAL_ACCEPTED',
    MATCHING_SHARED = 'MATCHING_SHARED',
    ROLE_SUBMITTED = 'ROLE_SUBMITTED',
    ROLE_DROPPED = 'ROLE_DROPPED',
}

export interface IEventType {
    channels: EChannel[];
    delayed: boolean;
    dynamicParameters: string[];
    immediate: boolean;
    source: EEventSource;
    type: EEventType;
}

export enum EEventSource {
    APPLICANT = 'APPLICANT',
    FREELANCER = 'FREELANCER',
    ADMINISTRATOR = 'ADMINISTRATOR',
    CLIENT = 'CLIENT',
    OTHER = 'OTHER'
}
